import { useContext } from "react";
import { ToastContext } from "../../App";

export const useToast = () => {
  const toast = useContext(ToastContext);

  const showSuccess = (summary: string, detail?: any) => {
    toast.current?.show({
      severity: "success",
      summary,
      detail,
      life: 3000
    });
  };

  const showError = (summary: string, detail: string) => {
    toast.current?.show({
      severity: "error",
      summary,
      detail,
      life: 3000
    });
  };

  const showWarn = (summary: string, detail: string) => {
    toast.current?.show({
      severity: "warn",
      summary,
      detail,
      life: 3000
    });
  };

  const showInfo = (summary: string, detail: string) => {
    toast.current?.show({
      severity: "info",
      summary,
      detail,
      life: 3000
    });
  };

  return { showSuccess, showError, showWarn, showInfo };
};